import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDpaF9S9cFZi-dog9wkG3yBCMnnqJKGMnA",
  authDomain: "medrphalab-c9bae.firebaseapp.com",
  projectId: "medrphalab-c9bae",
  storageBucket: "medrphalab-c9bae.appspot.com",
  messagingSenderId: "263734988551",
  appId: "1:263734988551:web:0606e6117210407a5fffa2",
  measurementId: "G-STQG337L74",
};

// 🔥 SAFE INIT (IMPORTANT FIX)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// 🔥 Messaging instance
let messaging = null;

// ⚠️ Safety check (browser only)
if (typeof window !== "undefined") {
  messaging = getMessaging(app);
}

// ✅ EXPORTS (IMPORTANT)
export { app, messaging };